<template>
  <form class="modal-integration-zoom p-6" @submit.prevent="$emit('submit')">
    <div class="d-flex align-items-start">
      <div class="flex-fill">
        <h4 class="title">Integração Zoom</h4>
        <a href="https://zoom.us/" target="_blank" class="link mb-9">
          Conheça o Zoom <i class="fa fa-external-link"></i>
        </a>
      </div>
      <button
        class="btn btn-sm btn-square"
        type="button"
        @click="$emit('close')"
      >
        <i class="icon-x fs-20 text-secondary" />
      </button>
    </div>

    <form-group
      v-model="form.client_id"
      id="client_id"
      label="Client_id"
      type="text"
      placeholder="Ex: C1NOtE62TzSaOvQPb4wl3w"
      :errors="errors.client_id"
    />
    <form-group
      v-model="form.client_secret"
      id="client_secret"
      label="Client_secret"
      type="text"
      placeholder="Ex: kgUEHSdyQj1hhyClbAEzyME95Lo3xXV0"
      :errors="errors.client_secret"
      class="mb-6"
    />

    <div class="d-flex justify-content-end">
      <button
        type="button"
        class="btn-sm btn-new-secondary fw-6 btn-40 py-0 px-5 mr-6"
        @click="$emit('close')"
      >
        Cancelar
      </button>
      <button
        type="submit"
        class="btn-sm btn-primary fw-6 btn-40 py-0 px-5"
        @click="$emit('submit')"
      >
        <b-spinner v-if="loading" variant="light" small></b-spinner>
        <span v-else>Integrar</span>
      </button>
    </div>
  </form>
</template>
<script>
export default {
  props: ["form", "errors", "loading"]
};
</script>
<style lang="scss" scoped>
.modal-integration-zoom {
  .title {
    color: var(--l-neutral-45);
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
  }
  .link {
    color: rgba(153, 85, 255, 0.87);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
  }
}
</style>
